<template>
  <div>
    <dt>{{ label }}</dt>
    <dd>{{ value }}</dd>
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-telefone",
  props: {
    label: String,
    value: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Telefone.vue